import * as React from "react";
import Helmet from "react-helmet";

const OgContent: React.FC = () => (
  <Helmet>
    <title>{"CeroFace | Achieve A Clear Complexion"}</title>

    <meta content="website" property="og:type" />
    <meta content="https://get.ceroface.com" property="og:url" />
    <meta content="CeroFace | Achieve A Clear Complexion" property="og:title" />
    <meta content="Dooer" property="og:site_name" />
    <meta
      content="Discover the easy solution to virtually eliminate blackheads in seconds."
      property="og:description"
    />
    <meta
      content="https://get.ceroface.com/images/og/og_index.jpg"
      property="og:image"
    />
    <meta content="image/png" property="og:image:type" />
    <meta content="1200" property="og:image:width" />
    <meta content="630" property="og:image:height" />
    <meta
      content="CeroFace, blackheads, clean, skin, removal"
      name="keywords"
    />
    <meta
      content="Discover the easy solution to virtually eliminate blackheads in seconds."
      name="description"
    />
    <meta
      content="CeroFace | Achieve A Clear Complexion"
      name="twitter:title"
    />
    <meta
      content="Discover the easy solution to virtually eliminate blackheads in seconds."
      name="twitter:description"
    />
    <meta
      content="https://get.ceroface.com/images/og/og_index.jpg"
      name="twitter:image"
    />

    <link href="https://get.ceroface.com" rel="canonical" />
  </Helmet>
);

export default OgContent;
